/** DEMO: true when the page runs on the in-memory mock backend (VITE_USE_MOCKS), so demo data is labelled. Read here, not from src/mocks, so production never loads the mock layer. */
const flag = import.meta.env.VITE_USE_MOCKS;
export const DEMO = flag === "1" || flag === "true";
